module.exports = __webpack_public_path__ + "static/media/mouse-pointer.f15ec190.svg";